import React, {useEffect, useState} from "react";
import {Box, Paper} from "@mui/material";
import { useTranslation } from "react-i18next";
import Users from "../Users";
import Messages from "../Messages";
import GroupMessageDialog from "../GroupMessageDialog";
import CardElement from "components/CardElement";
import {styled} from "@mui/material/styles";
import {faBuilding, faCommentPlus, faUsers, faUserPlus} from "@fortawesome/pro-solid-svg-icons";

const PaperElement = styled(Paper)(
	({ theme }) => `
	height: calc(100% - ${theme.spacing(1)});
	width: 100%;
	overflow-y: auto;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	overflow: hidden;
`
);

const Social = () => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [activeTab, setActiveTab] = useState(0);
	const [searchString, setSearchString] = useState("");

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	useEffect(() => {

	}, [activeTab]);

	return (
		<>
			<Box sx={{height: "50%"}}>
				<PaperElement elevation={2}>
					<Users/>
				</PaperElement>
			</Box>
			<Box sx={{height: "50%"}}>
				<PaperElement elevation={2}>
					<CardElement
						title={t("Messages")}
						menuItems={[
							{
								icon: faCommentPlus,
								primaryText: "New message",
								secondaryText: "Send a direct message",
								function: () => {}
							},
							{
								icon: faUsers,
								primaryText: "New group",
								secondaryText: "Start a groupchat",
								// function: () => { setOpen(true); }
								function: () => {}
							}
						]}
						moreActions={[
							{
								//icon: <FontAwesomeIcon icon={faList} size={"lg"} fixedWidth/>,
								label: t("All"),
								cb: () => { setActiveTab(0); },
								active: activeTab === 0
							},
							{
								//icon: <FontAwesomeIcon icon={faListCheck} size={"lg"} fixedWidth/>,
								label: t("Direct"),
								cb: () => { setActiveTab(1); },
								active: activeTab === 1
							},
							{
								//icon: <FontAwesomeIcon icon={faListCheck} size={"lg"} fixedWidth/>,
								label: t("Group"),
								cb: () => { setActiveTab(2); },
								active: activeTab === 2
							}
						]}
						search={{
							visible: true,
							searchString: searchString,
							setSearchString: setSearchString,
							placeholder: t("Search")
						}}
					>
						<Messages activeTab={activeTab} searchString={searchString}/>
						<GroupMessageDialog open={open} handleClose={handleClose}/>
					</CardElement>
				</PaperElement>
			</Box>
		</>
	);
};

export default Social;
